import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

// Layouts
import MainLayout from "@/components/layout/MainLayout";
import RoleRoute from "@/components/routing/RoleRoute";

// Pages
import {
  SignInPage,
  SignOutPage,
  AuthCallbackPage,
  AuthErrorPage,
  FilesPage,
  FolderPage,
  SharedWithMePage,
  SharedFolderPage,
  ShredderPage,
  SharePage,
  SupervisionPage,
  NotFoundPage,
} from "@/pages";

// Protected route wrapper
function ProtectedRoute() {
  return (
    <>
      <AuthenticatedTemplate>
        <Outlet />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/auth/signin" replace />
      </UnauthenticatedTemplate>
    </>
  );
}

export const router = createBrowserRouter(
  [
    // Auth routes (public)
    {
      path: "/auth",
      children: [
        { path: "signin", element: <SignInPage /> },
        { path: "signout", element: <SignOutPage /> },
        { path: "error", element: <AuthErrorPage /> },
        { path: "callback", element: <AuthCallbackPage /> },
      ],
    },

    // Public share routes
    {
      path: "/shared/:shareToken",
      element: <SharePage />,
    },

    // Protected routes
    {
      element: <ProtectedRoute />,
      children: [
        // Redirect root to share
        { path: "/", element: <Navigate to="/share" replace /> },

        // Main app routes with layout
        {
          element: <MainLayout />,
          children: [
            { path: "/share", element: <FilesPage /> },
            { path: "/share/shared-with-me", element: <SharedWithMePage /> },
            { path: "/share/shredder", element: <ShredderPage /> },
            { path: "/share/shared-folders/:folderId", element: <SharedFolderPage /> },

            // Supervisor group view (supervisor or superadmin app role)
            {
              element: <RoleRoute allow={["supervisor", "superadmin"]} />,
              children: [{ path: "/share/supervision", element: <SupervisionPage /> }],
            },

            { path: "/share/:folderId", element: <FolderPage /> },
          ],
        },
      ],
    },

    // 404
    { path: "*", element: <NotFoundPage /> },
  ]
  // El bloque `future` con las cinco banderas v7_* desaparece con la subida a
  // react-router 7: ahí ese comportamiento es el de por defecto y ya no hay
  // banderas que activar. Tenerlas puestas en v6 es lo que hace que esta
  // migración no cambie nada — la aplicación ya corría con esa semántica.
);
